// The signed-in session, kept in localStorage so a refresh does not log you out.
// The server issues a one-hour JWT; once it has expired the stored copy is
// worthless, so loading it clears it.

export const SESSION_KEY = 'pingdesk.session'

// What the server issues today. Only used if the token's own expiry can't be read.
const FALLBACK_LIFETIME_MS = 60 * 60 * 1000

// A JWT is three base64url parts; the middle one is JSON with `exp` in seconds.
function tokenExpiry(token) {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const { exp } = JSON.parse(atob(payload))
    return typeof exp === 'number' ? exp * 1000 : null
  } catch {
    return null
  }
}

export function loadSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const session = JSON.parse(raw)
    if (!session?.token || typeof session.expiresAt !== 'number' || session.expiresAt <= Date.now()) {
      localStorage.removeItem(SESSION_KEY)
      return null
    }
    return session
  } catch {
    // Blocked storage or a corrupt value — treat as signed out.
    return null
  }
}

export function saveSession({ token, user }) {
  const session = {
    token,
    user,
    expiresAt: tokenExpiry(token) ?? Date.now() + FALLBACK_LIFETIME_MS,
  }
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  } catch {
    // Non-fatal: the session still works until the page is reloaded.
  }
  return session
}

export function clearSession() {
  try {
    localStorage.removeItem(SESSION_KEY)
  } catch {
    // Nothing to clear if storage is blocked.
  }
}
